import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";


@Injectable({
  providedIn: 'root',
})
export class ChatbotService{
    private chatbotUrl = environment.chatBotUrl; 

    constructor(private _httpClient: HttpClient) {}

    validePaymentCMI(operationId: string,ticketId:string) {
        const url = `${this.chatbotUrl}/api/v1/whatsapp/payments-cmi/cmi/confirm/${operationId}`;
        return this._httpClient.put(url, {ticketId});
    }

    getTokenByPhoneSession(phone: string) {
        const url = `${this.chatbotUrl}/api/v1/whatsapp/user-sessions/token/${phone}`;
        return this._httpClient.get(url);
    }
}